import styles from "./KeywordCloud.module.scss";
import { KeywordCloud } from "Explore/Components";
import { TIME_FILTER_TYPE } from "Explore/Config/constraint";
import {
  getUnitGrantsKeywordsById,
  getUnitKeywordsById,
} from "Explore/Services/Unit";
import useExploreInfo from "Hooks/useExploreInfo";
import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setExploringKeyword,
  setSelectedKeywords,
  setTimeFilter,
} from "Redux/Slices/Concept";

const UnitDetailKeywordCloud = () => {
  const { unit_id } = useExploreInfo();
  const { exploringKeyword, selectedKeywords, timeFilter, tab } =
    useSelector((state) => state.conceptState) || {};
  const dispatch = useDispatch();

  const [concept, setConcept] = useState({ data: [], isLoading: false });
  const [_selectedKeywords, _setSelectedKeywords] = useState(selectedKeywords);
  const [granularityLevel, setGranularityLevel] = useState(1);
  const [granularityLevelQueue, setGranularityLevelQueue] = useState([]);
  const [selectedKeywordsQueue, setSelectedKeywordsQueue] = useState([]);

  const prevTab = useRef("");
  const prevExploringKeyword = useRef(null);

  useEffect(() => {
    if (!_.isEqual(_selectedKeywords, selectedKeywords)) {
      dispatch(setSelectedKeywords(_selectedKeywords));
    }
  }, [_selectedKeywords]);

  useEffect(() => {
    if (prevTab.current !== tab) {
      setSelectedKeywordsQueue([]);
      _setSelectedKeywords([]);
      setGranularityLevelQueue([]);
      prevTab.current = tab;
    }
    if (prevExploringKeyword.current !== exploringKeyword) {
      setConcept({ data: [], isLoading: true });
      setSelectedKeywordsQueue([[exploringKeyword]]);
      _setSelectedKeywords([exploringKeyword]);
      setGranularityLevel(exploringKeyword.level + 1);
      setGranularityLevelQueue([1]);
      prevExploringKeyword.current = exploringKeyword;
    } else {
      if (tab == "grants") {
        getUnitGrantsKeywordsById({
          id: unit_id,
          timeFilter,
          granularityLevel: granularityLevel - 1,
          rootConcept:
            selectedKeywordsQueue[selectedKeywordsQueue.length - 1] || null,
        }).then((res) => {
          setConcept({ data: res.keywords, isLoading: false });
        });
      } else {
        getUnitKeywordsById({
          id: unit_id,
          timeFilter,
          granularityLevel: granularityLevel - 1,
          rootConcept:
            selectedKeywordsQueue[selectedKeywordsQueue.length - 1] || null,
        }).then((res) => {
          setConcept({ data: res.keywords, isLoading: false });
        });
      }
    }
  }, [
    exploringKeyword,
    granularityLevel,
    selectedKeywordsQueue,
    timeFilter,
    unit_id,
    tab,
  ]);

  return (
    <div className={styles["keyword-cloud"]}>
      <KeywordCloud
        concept={concept}
        selectedKeywords={_selectedKeywords}
        setSelectedKeywords={_setSelectedKeywords}
        granularityLevel={granularityLevel}
        setGranularityLevel={setGranularityLevel}
        granularityLevelQueue={granularityLevelQueue}
        setGranularityLevelQueue={setGranularityLevelQueue}
        selectedKeywordsQueue={selectedKeywordsQueue}
        setSelectedKeywordsQueue={setSelectedKeywordsQueue}
        timeFilterType={TIME_FILTER_TYPE.DROPDOWN}
        timeFilter={timeFilter}
        setTimeFilter={(time) => dispatch(setTimeFilter(time))}
        chart_width={
          window.screen.width < 1024
            ? window.screen.width < 480
              ? null
              : 500
            : ""
        }
      />
    </div>
  );
};

export default UnitDetailKeywordCloud;
